import { Routes, Route, Navigate } from 'react-router-dom';
import { AppPaths, AppRoutes } from '../../utils/mapping/appRoutes.mapping';

import {
  LoginPage,
  NotFoundPage,
  HomePage,
  SignUpPage,
  ManageUserPage,
  ApproveTicketPage,
  AttendTicketPage,
  ContactsPage,
  CreateTicketPage,
  MyTicketsPage,
  ScheduledVisitsPage,
  RecordScheduledVisit,
  RequestsPage,
  NewRequestPage,
  CreationRoutePage,
  ConsolidatedMaterialsPage,
  ConsolidatedRecipePage,
  ConsolidatedVersionPage,
  RequestsSumaryPage,
  TypeMaterialPage,
  LoadMaterialPage,
  ResourcesPage,
  SpeedTrefiladoPage,
  SpeedVarillaPage,
  SpeedPlastificadoPage,
  SpeedAlambreGalvanizadoPage,
  SkuSheetOlimpicaPage,
  SkuSheetOlimpicaPlastificadaPage,
  IndicatorsPage,
} from '../pages';

import { PublicLayout, DashboardLayout } from '../layouts';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../app/features/auth/auth.slice';

const Routing = () => {
  const user = useSelector(selectCurrentUser);
  const isAllowed = ['eduar.huaman', 'miguel.flower'].includes(
    user?.username || '',
  );
  return (
    <Routes>
      <Route path={AppPaths.root}>
        <Route path={AppPaths.empty} element={<DashboardLayout />}>
          <Route path={AppPaths.home} element={<HomePage />} />
          <Route
            path={AppPaths.scheduledVisits}
            element={<ScheduledVisitsPage />}
          />
          <Route
            path={AppPaths.recordScheduledVisits}
            element={<RecordScheduledVisit />}
          />
          <Route
            path={AppPaths.empty}
            element={<Navigate to={AppRoutes.helpdesk} replace />}
          />
        </Route>
        <Route path={AppPaths.helpdesk} element={<DashboardLayout />}>
          <Route
            path={AppPaths.approveTicket}
            element={<ApproveTicketPage />}
          />
          <Route path={AppPaths.attendTicket} element={<AttendTicketPage />} />
          <Route path={AppPaths.contacts} element={<ContactsPage />} />
          <Route
            path={`${AppPaths.createTicket}/:id?`}
            element={<CreateTicketPage />}
          />
          <Route path={AppPaths.myTickets} element={<MyTicketsPage />} />
          <Route
            path={AppPaths.empty}
            element={<Navigate to={AppRoutes.myTickets} replace />}
          />
        </Route>
        <Route
          path={AppPaths.manufacturingRoutes}
          element={<DashboardLayout />}
        >
          {/* <Route path={AppPaths.indicators} element={<IndicatorsPage />} /> */}
          <Route
            path={AppPaths.indicators}
            element={isAllowed ? <IndicatorsPage /> : <RequestsPage />}
          />
          <Route path={AppPaths.requests} element={<RequestsPage />} />
          <Route
            path={AppPaths.requestsSumary}
            element={<RequestsSumaryPage />}
          />
          <Route path={AppPaths.newRequest} element={<NewRequestPage />} />
          <Route
            path={AppPaths.creationRoute}
            element={<CreationRoutePage />}
          />
          <Route
            path={AppPaths.consolidatedMaterials}
            element={<ConsolidatedMaterialsPage />}
          />
          <Route
            path={AppPaths.consolidatedRecipe}
            element={<ConsolidatedRecipePage />}
          />
          <Route
            path={AppPaths.consolidatedVersion}
            element={<ConsolidatedVersionPage />}
          />
          <Route path={AppPaths.loadMaterial} element={<LoadMaterialPage />} />
          {/* <Route
            path={AppPaths.empty}
            element={<Navigate to={AppRoutes.indicators} replace />}
          /> */}
          <Route
            path={AppPaths.empty}
            element={
              <Navigate
                to={isAllowed ? AppRoutes.indicators : AppRoutes.requests}
                replace
              />
            }
          />

          {/* Rutas para configuracion de rutas de fabricacion */}
          <Route path={AppPaths.manufacturingRoutesConfiguration}>
            <Route
              path={AppPaths.typeMaterials}
              element={<TypeMaterialPage />}
            />
            <Route path={AppPaths.resources} element={<ResourcesPage />} />
            <Route
              path={AppPaths.speedTrefilado}
              element={<SpeedTrefiladoPage />}
            />
            <Route
              path={AppPaths.speedPlastificado}
              element={<SpeedPlastificadoPage />}
            />
            <Route
              path={AppPaths.speedVarilla}
              element={<SpeedVarillaPage />}
            />
            <Route
              path={AppPaths.speedAlambreGalvanizado}
              element={<SpeedAlambreGalvanizadoPage />}
            />

            {/* Si entran a /configuration sin sub-ruta, los mandamos a materiales */}
            <Route
              path={AppPaths.empty}
              element={<Navigate to={AppRoutes.typeMaterials} replace />}
            />
          </Route>
          {/* Rutas para mantenedor de fichas */}
          <Route path={AppPaths.manufacturingRoutesSkuSheet}>
            <Route
              path={AppPaths.skuMallaOlimpica}
              element={<SkuSheetOlimpicaPage />}
            />
            <Route
              path={AppPaths.skuMallaOlimpicaPlastificada}
              element={<SkuSheetOlimpicaPlastificadaPage />}
            />
            {/* Si entran a /sku sin sub-ruta, los mandamos a olimpica */}
            <Route
              path={AppPaths.empty}
              element={<Navigate to={AppRoutes.skuMallaOlimpica} replace />}
            />
          </Route>
        </Route>

        <Route path={AppPaths.empty} element={<PublicLayout />}>
          <Route index path={AppPaths.login} element={<LoginPage />} />
          <Route path={AppPaths.signUp} element={<SignUpPage />} />
          <Route path={AppPaths.manageUser} element={<ManageUserPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default Routing;
